import React from 'react'

export const ConditionEvaluatorContext = React.createContext({ apiContext: null })
